import { env } from '@hb/mbridge';
import { appQueryConfig } from './url';
import { invoke } from './wechat';

const RENT_WX_APPID = 'wxa13c283ec22c0c22';
const RENT_ALIPAY_APPID = '2021002184676041';

export function navigateTo({
  miniPath = '',
  appPath = '',
}) {
  if (env.isEasyBikeApp) {
    window.location.href = appPath;
    return;
  }

  let switchCase = false;

  if (/pages\/homepage|userCenter\/index/.test(miniPath)) {
    switchCase = true;
  }

  if (env.isAliMP) {
    if (switchCase) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      window.my.switchTab({
        url: miniPath,
      });
      return;
    }

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window.my.navigateTo({
      url: miniPath,
    });
  }

  if (env.isWechatMini) {
    if (switchCase) {
      invoke((wx) => {
        wx.miniProgram.switchTab({
          url: miniPath,
        });
      });
      return;
    }

    invoke((wx) => {
      wx.miniProgram.navigateTo({
        url: miniPath,
      });
    });
  }
}

export function versionCompare(ver1: string, ver2: string) {
  const v1 = ver1 || '0.0.0';
  const v2 = ver2 || '0.0.0';
  if (v1 === v2) {
    return 0;
  }
  const v1Arr = v1.split('.');
  const v2Arr = v2.split('.');
  const len = Math.max(v1Arr.length, v2Arr.length);

  for (let i = 0; i < len; i += 1) {
    const v1Item = typeof Number(v1Arr[i]) === 'number' ? Number(v1Arr[i]) : 0;
    const v2Item = typeof Number(v2Arr[i]) === 'number' ? Number(v2Arr[i]) : 0;
    if (v1Item < v2Item) {
      return -1;
    } if (v1Item > v2Item) {
      return 1;
    }
  }
  return 0;
}
/**
 * 判断是否是电动车微信、支付宝小程序环境
 *
 * @export
 * @return {*}  {boolean}
 */
export function isRentMini(): boolean {
  const { appId } = appQueryConfig;

  if (env.isAliMP && appId === RENT_ALIPAY_APPID) return true;

  if (env.isWechatMini && appId === RENT_WX_APPID) return true;

  if (env.isEasyBikeApp) return true;

  return false;
}

export default {

};
